import * as React from "react";

import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconCheck: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faCheck} />;
};
